class WCQuantitySelector extends WCObservable(WCDummy) {
  #dec;
  #inc;
  #input;
  #max;
  #form;
  #cartQuantity = 0;

  static get tag() {
    return "wc-quantity-selector";
  }

  constructor() {
    super({ tag: WCQuantitySelector.tag, hasStylesheet: true });
    this.#input = this.querySelector("input");

    this.append(this.appendStyles());
  }

  connectedCallback() {
    this.#input = this.querySelector("input");
    if (!this.#input.hasAttribute("form")) {
      this.#form = this.closest("form[id^=product_form]");
      this.#form &&
        this.#input.setAttribute("form", this.#form.getAttribute("id"));
    }

    this.#input.value = this.#input.value || this.min;
    this.#input.setAttribute("min", this.min);
    if (!this.syncCart) {
      this.#max = this.max = this.#input.max;
    }

    if (!isNaN(parseInt(this.#max)) && this.#max <= this.min) {
      this.#input.value = this.#max;
    }

    // let shadow = this.attachShadow({ mode: "open" });
    // shadow.append(this.#input);
    // this.shadow = shadow;

    this.notify = this.notify.bind(this);
    this.initObserver();

    if (this.max) {
      if (this.observeCart) {
        ShopifyAjaxAPI.cart.then((cart) =>
          this.#handleCartChange.bind(this)({ detail: cart })
        );
        document.addEventListener(
          "cartChanged",
          this.#handleCartChange.bind(this)
        );
      }
    }
    this.value = parseInt(this.#input.value);
    this.notify();
  }
  disconnectedCallback() {}
  observerCallback() {
    if (this.buttons) {
      this.#dec = document.createElement("button");
      this.#inc = document.createElement("button");
      // shadow.prepend(this.#dec);
      // shadow.append(this.#inc);
      this.prepend(this.#dec);
      this.append(this.#inc);
      this.#dec.innerText = "-";
      this.#inc.innerText = "+";
      this.#handleButtonBoundaries(this.#dec);
      this.#handleButtonBoundaries(this.#inc);
      this.#dec.addEventListener(
        "click",
        debounce({
          callback: (e) => this.#handleInputChange(e),
          sleep: 300,
          preHook: (e) => this.#handleButtonClick(e),
        }).bind(this)
      );
      this.#inc.addEventListener(
        "click",
        debounce({
          callback: (e) => this.#handleInputChange(e),
          sleep: 300,
          preHook: (e) => this.#handleButtonClick(e),
        }).bind(this)
      );
    }
    this.#handleButtonBoundaries(this.#dec);
    this.#handleButtonBoundaries(this.#inc);
    this.#input.addEventListener(
      "input",
      debounce({
        callback: (e) => this.#handleInputChange(e),
        sleep: 500,
      }).bind(this)
    );
  }
  get variantId() {
    return parseInt(this.getAttribute("variant-id"));
  }

  get buttons() {
    return this.getAttribute("buttons") === "false" ? false : true;
  }

  get syncCart() {
    return this.hasAttribute("sync-cart");
  }

  get observeCart() {
    return this.getAttribute("observe-cart") === "false" ? false : true;
  }

  get min() {
    return this.hasAttribute("allow-zero") ? 0 : 1;
  }

  set cartQuantity(value) {
    this.#cartQuantity = value;
    this.max = this.#max - value;
    this.#input.max = this.max;
    if (this.max <= this.min) {
      this.#input.value = this.max;
    } else {
      this.#input.value = this.min;
    }
    this.value = parseInt(this.#input.value);
    this.notify();
    this.#handleButtonBoundaries(this.#dec);
    this.#handleButtonBoundaries(this.#inc);
  }

  #handleButtonClick(e) {
    e.preventDefault();
    switch (e.srcElement.innerText) {
      case "-":
        this.#input.stepDown();
        break;
      case "+":
        this.#input.stepUp();
        break;
      default:
        break;
    }
  }

  #handleInputChange() {
    if (this.syncCart) {
      ShopifyAjaxAPI.change({
        id: `${this.variantId}`,
        quantity: this.#input.value,
      }).then((cart) => {
        this.#input.value = cart.items.find(
          (item) => item.variant_id === this.variantId
        )?.quantity;
        this.value = parseInt(this.#input.value);
        this.notify();
      });
    }
    this.max &&
      parseInt(this.#input.value) > parseInt(this.max) &&
      (this.#input.value = this.max);
    this.value = parseInt(this.#input.value);
    this.notify();
    this.#handleButtonBoundaries(this.#dec);
    this.#handleButtonBoundaries(this.#inc);
  }
  #handleButtonBoundaries(button) {
    if (button) {
      switch (button.innerText) {
        case "-":
          if (this.#input.value <= this.min) {
            button.setAttribute("disabled", "");
          } else {
            button.removeAttribute("disabled");
          }
          break;
        case "+":
          if ((this.max && this.#input.value >= this.max) || this.max === 0) {
            button.setAttribute("disabled", "");
          } else {
            button.removeAttribute("disabled");
          }
          break;
        default:
          break;
      }
    }
  }
  #handleCartChange(e) {
    const cart = e.detail;
    const variant = cart.items.find(
      (item) => item.variant_id === this.variantId
    );
    if (variant) {
      this.cartQuantity = variant.quantity;
    } else {
      this.cartQuantity = 0;
    }
  }

  notify() {
    this.dispatchEvent(
      new CustomEvent("change", {
        detail: parseInt(this.#input.max),
      })
    );
  }

  cloneNode() {
    const canidate = super.cloneNode(true);
    canidate.setAttribute("observe-cart", false);
    canidate.replaceChildren(this.#input.cloneNode(true));
    return canidate;
  }
}

customElements.define(WCQuantitySelector.tag, WCQuantitySelector);
